import { Card, CircleUserIcon, Skeleton } from '@execonline-inc/execonline-ui';

function RecentlyLoggedInSkeleton() {
  return (
    <>
      <div className="w-[47.4%] mb-4 mt-7">
        <Skeleton variant="text" className="h-5 w-1/3 mr-4 mb-4" />
        <Card className="pl-[5%] pt-[3%] pr-[5%] pb-[3%]" radius="lg">
          <div className="flex justify-between">
            <Skeleton variant="text" className="w-24 h-6" />
            <Skeleton variant="text" className="w-16 h-6" />
          </div>
          {[...Array(5)].map((_, index) => (
            <div className="flex justify-between mt-4" key={index}>
              <div className="flex items-center">
                <CircleUserIcon color="gray" className="mr-2 text-[1.5rem]" />
                <Skeleton variant="text" className="w-24 h-6" />
              </div>
              <Skeleton className="w-16 h-6" />
            </div>
          ))}
        </Card>
      </div>
    </>
  );
}

export default RecentlyLoggedInSkeleton;
